import React from 'react';
import { getProductAnalytics } from '../../../services/analyticsApi';

const TopProduct = () => {
  const [top, setTop] = React.useState({
    name: 'High-Visibility Safety Jacket',
    units: 1247,
    image: '/assets/product-image.webp',
  });

  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const d = await getProductAnalytics();
        const first =
          Array.isArray(d?.topProducts) && d.topProducts.length
            ? d.topProducts[0]
            : null;
        if (first && mounted) {
          setTop({
            name: first.name || first.productName || 'Top Product',
            units: first.orders || first.quantity || 0,
            image: first.image || '/assets/product-image.webp',
          });
        }
      } catch (_) {
        // keep fallback
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div
      className="bg-white rounded-[12px] p-6"
      style={{ boxShadow: '0px 4px 16px 0px #0000001A' }}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-6">
        <div>
          <h2 className="text-[#373737] poppins text-[24px] leading-[36px] tracking-[-0.96px] font-bold mb-1">
            Top Product
          </h2>
          <p className="text-[#9CA3AF] poppins text-[14px] leading-[21px] tracking-[-0.56px]">
            Based on total sold
          </p>
        </div>
        <button className="text-[#374151] poppins text-[14px] leading-[21px] tracking-[-0.56px] font-medium hover:text-[#1F2937] transition-colors">
          View More
        </button>
      </div>

      {/* Product Display */}
      <div className="flex  justify-center items-center gap-1">
        {/* Product 1 */}
        <div className="flex flex-col items-center">
          <div className="w-40 h-auto bg-white  overflow-hidden">
            <img
              src="/assets/product-image.webp"
              alt="High-Visibility Safety Jacket"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Product 2 */}
        <div className="hidden md:flex flex-col items-center">
          <div className="w-40 h-auto bg-white  overflow-hidden">
            <img
              src="/assets/product-image.webp"
              alt="High-Visibility Safety Jacket"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* Product Info */}
      <div className="text-center mt-6">
        <h3 className="text-[#374151] poppins text-[16px] leading-[24px] tracking-[-0.64px] font-semibold">
          {top.name}
        </h3>
        <p className="text-[#6B7280] poppins text-[14px] leading-[21px] tracking-[-0.56px] mt-1">
          {top.units?.toLocaleString()} units sold this month
        </p>
      </div>
    </div>
  );
};

export default TopProduct;
